import ServiceComponent from './ServiceComponent';
import { AppTheme } from '../../../theme';

export const confirmDialog = ServiceComponent.create({ customTheme: AppTheme });
